/* Styling only. Flex remains responsible for product data and purchase behavior. */
(() => {
  'use strict';
  if (customElements.get('effy-product-style')) return;

  const adapters = new Set();
  const syncBodyClass = () => {
    document.body.classList.toggle(
      'effy-standard-product-view',
      [...adapters].some(adapter => adapter.nativeSection?.isConnected)
    );
  };

  class EffyProductStyle extends HTMLElement {
    connectedCallback() {
      adapters.add(this);
      this.attach();
    }

    disconnectedCallback() {
      adapters.delete(this);
      this.detach();
      syncBodyClass();
    }

    attach() {
      const target = document.getElementById(this.dataset.nativeSectionId);
      // An unrelated section or missing native product must never be restyled.
      if (!target?.querySelector('.js-product_section')) {
        this.detach();
        syncBodyClass();
        return;
      }
      if (target !== this.nativeSection) this.detach();
      this.nativeSection = target;
      target.classList.add('effy-product-native');
      syncBodyClass();
    }

    detach() {
      if (this.nativeSection) {
        const usedByAnotherAdapter = [...adapters].some(
          adapter => adapter !== this && adapter.nativeSection === this.nativeSection
        );
        if (!usedByAnotherAdapter) this.nativeSection.classList.remove('effy-product-native');
      }
      this.nativeSection = null;
    }
  }

  customElements.define('effy-product-style', EffyProductStyle);
  // Reattach when the theme editor replaces the native product section.
  document.addEventListener('shopify:section:load', () => {
    adapters.forEach(adapter => adapter.attach());
  });
  document.addEventListener('shopify:section:unload', event => {
    adapters.forEach(adapter => {
      if (event.target === adapter.nativeSection || event.target.contains?.(adapter)) {
        adapter.detach();
      }
    });
    syncBodyClass();
  });
})();
